import "./gatePassSystem.css";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, NavItem, Table} from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as React from 'react';
import GatePassPopUp from "./gatePassPopUp";
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { confirmAlert } from 'react-confirm-alert';
import { Button, Box, Card, IconButton, MenuItem, Popover, Stack, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography, Tab, CardContent } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { PROD } from "../../../common/constants";

function GatePassSystem(){

    const navigate = useNavigate();

    const addVehicleDetails = (e) => {
        e.preventDefault();
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <GatePassPopUp  onClose={onClose} />
                );
            }
        });
    }

    const columns = [
        { field: 'token', headerName: 'Token No', width: 250 },
        {
            field: 'no', type: 'date', headerName: 'Consignment No', width: 250,
            // valueFormatter: params => moment(params?.value).format("DD/MM/YYYY"),
        },
        { field: 'regNo', headerName: 'Vehicle Registration No', width: 250 },
        { field: 'Dname', headerName: 'Driver Name', width: 250 },
        { field: 'dcont', headerName: 'Driver Contact', width: 250 },
        { field: 'time', headerName: 'Gate Entry Time', width: 250 },
        { field: 'Extime', headerName: 'Gate Exit Time', width: 250 },
        { field: 'status', headerName: 'Verification Status', width: 250 },
    ];

    return(
        <div>
            <Container fluid>
                <Row>
                    {/* <Col xs={12} md={3} className='common-internal-sidebar-col'>
                      <div className="common-internal-sidebar-container">
                        <ArrowBackIosNew className="arrow-icon" onClick={() => (navigate('/dashboardStakeHolder'))} />
                      </div>                  
                    </Col> */}
                    <Col xs={12} md={12}>
                        <div>
                        {!PROD &&    <p style={{textAlign:"center", fontSize:"2vh"}}>PIT29</p> }
                            <form>                              
                               <Container fluid>
                               <div className='headingStylePIT'>Gate Pass System</div>
                                  <Row>
                                    <div className="col">Add Vehicle Entry Details</div>
                                    <div className="col-md-12">
                                        <button className="gate-pass-add" onClick={(e)=>addVehicleDetails(e)}>Click to Add</button>
                                    </div>
                                  </Row>
                               </Container>
                               <Card>
                                    <Box style={{ height: 500, width: '100%' }}>
                                        {/* {
                                            invoiceDetails && */}
                                            <DataGrid rows
                                                columns={columns}
                                                pageSize={10}
                                                components={{ Toolbar: QuickSearchToolbar }}
                                            />
                                        {/* } */}

                                    </Box>
                                </Card>

                               {/* </Container> */}
                            </form>
                        </div>
                        <Row>
                            <Col xs={12} md={6}>
                                <div class="plant_cb_submit-div">
                                    <button className='plant_cb_submit-Btn ' type='submit'>Submit</button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default GatePassSystem;